import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataDeliveryTermsActions } from "./delivery-terms.actions";

// **************************************************************************
// DELIVERY TERMS REDUCER
// **************************************************************************

const load = on(DataDeliveryTermsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        deliveryTerm: {
            ...state.data.deliveryTerm,
            deliveryTermsLoading: true,
        },
    },
}));

const loadSuccess = on(DataDeliveryTermsActions.loadSuccess, (state: ApplicationStore, { deliveryTerms }) => ({
    ...state,
    data: {
        ...state.data,
        deliveryTerm: {
            ...state.data.deliveryTerm,
            deliveryTerms,
            deliveryTermsLoading: false,
        },
    },
}));

const loadFailure = on(DataDeliveryTermsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        deliveryTerm: {
            ...state.data.deliveryTerm,
            deliveryTermsLoading: false,
        },
    },
}));

export const deliveryTermsReducer = [load, loadSuccess, loadFailure];
